export const KAIROS_QOL_KEY_OBJECT_SERIES_MARKER = 'KAIROS_QOL_INTERNAL_KEY_OBJECT_SERIES';

export const buildKeyObjectMark = (payload = {}, ordinal = 0) => {
  const series = payload.series || {};
  const slice = Math.max(0, Math.floor(Number(payload.slice) || 0));
  const annotation = payload.annotation || null;
  const id = `${series.studyInstanceUID || 'study'}:${series.seriesInstanceUID || 'series'}:${slice}:${annotation?.id || 'image'}`;
  return {
    id,
    ordinal,
    studyInstanceUID: series.studyInstanceUID,
    seriesInstanceUID: series.seriesInstanceUID,
    seriesDescription: series.seriesDescription || `Series ${series.seriesNumber || ''}`.trim(),
    modality: series.modality,
    seriesNumber: series.seriesNumber,
    slice,
    annotation: annotation ? { id: annotation.id, type: annotation.type || 'object', text: annotation.text || annotation.label || '' } : null,
    series,
  };
};

export const buildKeyObjectVirtualSeries = (mark = {}) => ({
  ...(mark.series || {}),
  seriesInstanceUID: mark.seriesInstanceUID,
  studyInstanceUID: mark.studyInstanceUID,
  modality: mark.modality || mark.series?.modality || 'KO',
  seriesNumber: mark.seriesNumber || mark.series?.seriesNumber || 'KO',
  seriesDescription: `KEY ${mark.annotation ? 'OBJECT' : 'IMAGE'} · ${mark.seriesDescription || mark.series?.seriesDescription || 'Series'} · IMG ${Math.max(0, Math.floor(Number(mark.slice) || 0)) + 1}`,
  _kairosKeyObjectId: mark.id,
  _kairosInitialSlice: Math.max(0, Math.floor(Number(mark.slice) || 0)),
  _kairosThumbnailSlice: Math.max(0, Math.floor(Number(mark.slice) || 0)),
});
